module.exports = __webpack_public_path__ + "img/image_loading.b2cec27f.svg";